/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_ApplyInputs */

const en_us2_update_apply = /** @type {(inputs: Update_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update`)
};

const pt_br2_update_apply = /** @type {(inputs: Update_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar`)
};

const es_419_update_apply = /** @type {(inputs: Update_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar`)
};

const pt_pt2_update_apply = /** @type {(inputs: Update_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar`)
};

const fr_fr2_update_apply = /** @type {(inputs: Update_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour`)
};

const de_de2_update_apply = /** @type {(inputs: Update_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisieren`)
};

const it_it2_update_apply = /** @type {(inputs: Update_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna`)
};

/**
* | output |
* | --- |
* | "Update" |
*
* @param {Update_ApplyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const update_apply = /** @type {((inputs?: Update_ApplyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_ApplyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_update_apply(inputs)
	if (locale === "es-419") return es_419_update_apply(inputs)
	if (locale === "pt-PT") return pt_pt2_update_apply(inputs)
	if (locale === "fr-FR") return fr_fr2_update_apply(inputs)
	if (locale === "de-DE") return de_de2_update_apply(inputs)
	if (locale === "it-IT") return it_it2_update_apply(inputs)
	return en_us2_update_apply(inputs)
});
export { update_apply as "update.apply" }